



import Vue from 'vue'
import axios from 'axios'
export default Vue.extend({
  name: 'app',
  created() {
    setTimeout(() => {
      let utm_ad = sessionStorage.getItem('utm_ad') ? sessionStorage.getItem('utm_ad') : null
      if(utm_ad) {
        axios.get('https://api.app.sectoredge.io/api/efforts/redirect/' + utm_ad)
        .then((res) => {
          if(res.data.redirect == true) {
            window.location.href = res.data.redirect_url
          }
        }).catch(() => {
          console.log('Error has occured with redirect endpoint')
        })
      }
    }, 1000)
    
    if (window.location.hostname == 'localhost' || window.location.hostname == 'microsite-staging.netlify.app') {
      this.$gtag.set({
        'traffic_type': 'internal',
      })
    }
  },

  mounted() {
    setTimeout(() => {
      $('img').css('max-width', '100%')
      $('img').css('height', 'auto')
      $('img').addClass('mx-auto')
      $('img').addClass('d-block')
      $('img').addClass('my-1')
    }, 1000);
  },
});
